import React from 'react';
import { Container } from '@mui/material';
import { Views } from '@pages/home/components';

interface IHomeProps {}

export const Home: React.FC<IHomeProps> = () => (
    <Container>
        <Views />
    </Container>
);
